import type { ReactElement } from "react";
import type { EditableCharacter } from "../lib/character-edits.js";
import CharacterAspectsEditor from "./CharacterAspectsEditor.js";
import CharacterConsequencesEditor from "./CharacterConsequencesEditor.js";
import CharacterExtrasEditor from "./CharacterExtrasEditor.js";
import CharacterFpEditor from "./CharacterFpEditor.js";
import CharacterSkillsEditor from "./CharacterSkillsEditor.js";
import CharacterStressEditor from "./CharacterStressEditor.js";

export default function CharacterEditor({
  characterPath,
  character,
}: {
  characterPath: string;
  character: EditableCharacter;
}): ReactElement {
  return (
    <article className="space-y-6 p-4">
      <h1 className="text-2xl font-bold">{character.name}</h1>
      <CharacterFpEditor characterPath={characterPath} character={character} />
      <CharacterAspectsEditor characterPath={characterPath} character={character} />
      <CharacterSkillsEditor characterPath={characterPath} character={character} />
      <CharacterStressEditor characterPath={characterPath} character={character} />
      <CharacterConsequencesEditor characterPath={characterPath} character={character} />
      <CharacterExtrasEditor characterPath={characterPath} character={character} />
    </article>
  );
}
